import { ReactElement, useEffect, useState } from 'react';
import { FcpContractorDetails, useFetchFpcDetails } from '@services/hooks/contractor360/useFetchFpcDetails';
import { Wrapper } from '@components/common/Wrapper/wrapper';
import { IContractorFpcDetailsProps } from '.';

export const ContractorFpcDetails = ({ title, membershipNo }: IContractorFpcDetailsProps): ReactElement => {
	const [fcpData, setFcpData] = useState<FcpContractorDetails[]>([]);
	const { mutate: fetchContractorFpcList, isPending, error } = useFetchFpcDetails();

	useEffect(() => {
		fetchContractorFpcList(
			{ membershipNo },
			{
				onSuccess: (res) => {
					if (res?.data) setFcpData(res.data);
				},
			}
		);
	}, [fetchContractorFpcList, membershipNo]);

	return (
		<div className="details-history-card-table">
			{title && <div className="title-with-line">{title}</div>}
			<Wrapper isLoaderVisible={isPending} isError={error}>
				<table className="history-table mt-4">
					<thead>
						<tr>
							<th className="popup-table-head">Sub Contractor Name</th>
							<th className="popup-table-head">YTD Banking</th>
						</tr>
					</thead>
					<tbody>
						{fcpData?.length > 0 ? (
							fcpData.map((product) => (
								<tr key={product.name}>
									<td className="center-block">{product.name}</td>
									<td className="center-block">{product.ytd_banking ?? 0}</td>
								</tr>
							))
						) : (
							<tr>
								<td colSpan={2}>
									<p className="h3 text-center">No Records Found</p>
								</td>
							</tr>
						)}
					</tbody>
				</table>
			</Wrapper>
		</div>
	);
};
